import * as React from 'react';
import IconService from '../../../../../Services/IconService';
import { IVehicleWithData, TVehicleStatus } from '../../../../Vehicles/types';

interface SvgIconProps {
  vehicle: IVehicleWithData;
  isSelected?: boolean;
  forceVehicleTypeId?: number;
  angle: number;
  status: TVehicleStatus;
  mode: string;
}

function SvgIcon(props: SvgIconProps): JSX.Element | null {
  if (!props.vehicle || !props.vehicle.position) {
    return null;
  }
  const svgData = IconService.getVehicleIcon(
    props.forceVehicleTypeId || props.vehicle.vehicleTypeId,
    props.vehicle.status && props.mode === 'business'
      ? props.status
      : props.mode === 'private'
      ? 'PRIVATE'
      : 'UNKNOWN',
    props.angle,
    true,
    1,
    props.forceVehicleTypeId ? false : props.isSelected
  );
  return <img src={svgData} alt="" width="50" height="50" />;
}

SvgIcon.defaultProps = {
  isSelected: false,
};

export default SvgIcon;
